module.exports = __webpack_public_path__ + "static/media/yuuki-asuna-win.d4ed2a6d.png";